var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showCollectConfirmation
    ? _c(
        "div",
        [
          _c(
            "b-modal",
            {
              attrs: {
                active: _vm.showCollectConfirmation,
                "has-modal-card": "",
                "full-screen": "",
              },
              on: {
                "update:active": function ($event) {
                  _vm.showCollectConfirmation = $event
                },
              },
            },
            [
              _c("collectConfirmation", {
                attrs: {
                  "selected-group": _vm.selectedGroup,
                  collect: _vm.selectedCollect,
                },
                on: {
                  close: function ($event) {
                    _vm.showCollectConfirmation = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", { staticClass: "modal-card", staticStyle: { width: "auto" } }, [
        _c("div", { staticClass: "modal-card-head centered-items" }, [
          _c("div", { staticClass: "centered-items" }, [
            _c("h2", { staticClass: "title" }, [
              _vm._v(
                " " + _vm._s(_vm.enduserCode + " - " + _vm.enduserName) + " "
              ),
            ]),
            _c("h2", { staticClass: "subtitle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("pages.pickup_management.calendar.infos.week")
                  ) +
                  " " +
                  _vm._s(_vm.week) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c(
          "section",
          {
            staticClass: "modal-card-body",
            attrs: { id: "calendar-step-coll-screen" },
          },
          [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-warning is-outlined is-small",
                  attrs: { id: "calendar-step-coll-screen-back" },
                  on: { click: _vm.closeInfos },
                },
                [
                  _c("b-icon", { attrs: { icon: "chevron-left" } }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "custom-columns" },
              _vm._l(_vm.computedCollects, function (collect) {
                return _c(
                  "div",
                  { key: collect.id, staticClass: "custom-column" },
                  [
                    _c(
                      "div",
                      { staticClass: "associated-collects" },
                      [
                        _c("collectInfoCard", {
                          attrs: { associated: false, collect: collect },
                          on: {
                            deleteCollect: _vm.deleteCollect,
                            collectConfirmation: _vm.collectConfirmation,
                          },
                        }),
                        _vm._l(collect.associated, function (ac) {
                          return _c(
                            "div",
                            {
                              key: ac.enduserCode,
                              staticClass: "associated-columns",
                            },
                            [
                              _c("div", { staticClass: "line" }),
                              _c("collectInfoCard", {
                                staticClass: "associated-collect",
                                attrs: { associated: true, collect: ac },
                                on: {
                                  deleteCollect: _vm.deleteCollect,
                                  collectConfirmation: _vm.collectConfirmation,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }